import React from 'react';
import { defineMessages } from 'react-intl';

import { PILL_GRAPH_COLORS, PILL_GRAPH_DATA_TYPES } from 'components/PillGraph';
import Message from 'components/Message';

const messages = defineMessages({
  legendSpots: {
    id: 'yield-management.insights.reservations-graph.legend.spots',
    defaultMessage: 'Spots',
  },
  legendCpBookings: {
    id: 'yield-management.insights.reservations-graph.legend.cp-bookings',
    defaultMessage: 'CP Bookings',
  },
  legendUnfilled: {
    id: 'yield-management.insights.reservations-graph.legend.unfilled',
    defaultMessage: 'Unfilled',
  },
  legendNonCp: {
    id: 'yield-management.insights.reservations-graph.legend.non-cp',
    defaultMessage: 'Non-ClassPass',
  },
  graphSpotsTaken: {
    id: 'yield-management.insights.reservations-graph.data.spots-taken',
    defaultMessage: '{classpassBooked, number} of {classpassTotal, plural, one {# spot} other {# spots}} reserved',
  },
  graphUnfilled: {
    id: 'yield-management.insights.reservations-graph.data.unfilled',
    defaultMessage: '{unfilledSpots, plural, one {# unfilled spot} other {# unfilled spots}}',
  },
  graphNonCp: {
    id: 'yield-management.insights.reservations-graph.data.non-classpass',
    defaultMessage:
      '{directReservations, plural, one {# non-classpass reservation} other {# non-classpass reservations}}',
  },
});

export const deriveReservationsGraphLegendItems = noDirectFillData => {
  const graphLegendItems = [
    {
      key: 'classpass-booked',
      color: PILL_GRAPH_COLORS.GREEN,
      value: <Message message={messages.legendCpBookings} />,
      type: PILL_GRAPH_DATA_TYPES.ALLOCATION,
    },
    {
      key: 'unfilled',
      color: PILL_GRAPH_COLORS.GRAY,
      value: <Message message={messages.legendUnfilled} />,
      type: PILL_GRAPH_DATA_TYPES.ALLOCATION,
    },
  ];

  if (!noDirectFillData) {
    graphLegendItems.push({
      key: 'non-cp',
      color: PILL_GRAPH_COLORS.DARK_BLUE,
      value: <Message message={messages.legendNonCp} />,
      type: PILL_GRAPH_DATA_TYPES.ALLOCATION,
    });
  }

  return graphLegendItems;
};

export const deriveReservationsGraphData = (noDirectFillData, schedule) => {
  const { spots: { classpassBooked, classpassTotal, maxCapacity, totalBooked } = {} } = schedule;
  const directReservations = noDirectFillData ? 0 : totalBooked - classpassBooked;
  const unfilledSpots = noDirectFillData ? classpassTotal - classpassBooked : maxCapacity - totalBooked;

  const graphData = [
    {
      key: 'classpass-booked',
      color: PILL_GRAPH_COLORS.GREEN,
      value: classpassBooked,
      label: (
        <Message
          message={messages.graphSpotsTaken}
          values={{
            classpassBooked,
            classpassTotal,
          }}
        />
      ),
    },
    {
      key: 'unfilled',
      color: PILL_GRAPH_COLORS.GRAY,
      value: unfilledSpots,
      label: <Message message={messages.graphUnfilled} values={{ unfilledSpots }} />,
    },
    {
      key: 'noncp',
      color: PILL_GRAPH_COLORS.DARK_BLUE,
      value: directReservations,
      label: <Message message={messages.graphNonCp} values={{ directReservations }} />,
    },
  ];

  return graphData;
};
